import { render, staticRenderFns } from "./ViewApproverVerificationSectionData.vue?vue&type=template&id=4e08c5d0&scoped=true"
import script from "./ViewApproverVerificationSectionData.vue?vue&type=script&lang=js"
export * from "./ViewApproverVerificationSectionData.vue?vue&type=script&lang=js"
import style0 from "./ViewApproverVerificationSectionData.vue?vue&type=style&index=0&id=4e08c5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08c5d0",
  null
  
)

export default component.exports